import React from 'react';
import mainTpl from '../templates/main';
import GreenCardsModel from '../../../Cards/models/greenCards.m';
import {apiback} from '../../../../config';
import BaseNewCardView from '../../views/BaseNewCardView';
import {canUseDOM} from '../../../../helpers/canUseDOM';

export default class extends BaseNewCardView {
    template = mainTpl;

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            ui: this.uiStates.INITIAL,
            model: {},
            tab: 'tariffs',
            tabPossibilities: 'platinum'
        };
    }

    togglePossibilitiesTab = tab => {
        this.setState({tabPossibilities: tab});
    };

    setTheme = theme => {
        document.documentElement.classList.remove('light', 'dark');
        document.documentElement.classList.add(theme);
    };

    componentDidMount() {
        super.componentDidMount();
        this.props.setForcedTheme('dark');
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        this.props.clearForcedTheme();
    }

    componentWillMount() {
        super.componentWillMount();
        if (!canUseDOM) return;
        fetch(apiback('CREDIT_CARDS'))
            .then(res => res.json())
            .then(json =>
                this.setState({
                    model: new GreenCardsModel(json.data['platinum_card'])
                })
            );
    }

    static displayName = 'ProfitCard.Views.Main';
}
